module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("THE PEOPLE OF THE FOLSOM PRISON BREAK OF 1903")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IST OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONVICTS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SCAPED")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLSOM")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISON ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULY")]), _vm._v(" 27, 1903, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIMES FOR")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINALLY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTENCED")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Joseph “J.J.” “The Lone Kid” Allison, four years, robbery and burglary/ second degree")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Frank Case, life, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Edward Davis, thirty-three years, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Harry “The Borer” Eldridge, thirty years, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Ray Fahey, life, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Richard M. “Red” Gordon, forty-five years, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Fred Howard, fifteen years, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Frank “The Little Dutchman” Miller, twelve years, burglary/first degree")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Joseph Murphy, fourteen years, burglary")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("James P. “Smiley” Roberts, twenty years, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Albert Seavis, twenty-five years, burglary")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Joseph Theron, life, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John H. “Tex” Wood, life, robbery")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLSOM")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAFF")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Thomas Wilkinson, warden")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Harry Wilkinson, stenographer (the warden’s grandson)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("R.J. Murphy, captain of the guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("W.A. Chalmers, gatekeeper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William Cotter, guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Joseph Cochrane, general overseer")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Guy Jeter, foreman of the prison quarry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Henry Kipp, lieutenant of the guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("J.G. McDonough, general overseer")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles Ward, master mechanic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("J. Klenzendorf, guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("L.C. Vetress Jr., guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Guy Jeter, guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles H. Jolly, guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("O. Seavy, guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("James Dolan, guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William Hopton, guard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("T.C. Brown, stagecoach driver")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Archibald Yell, warden")]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead2"
  }, [_c('i', [_vm._v("Placer County")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles Keena, sheriff, Placer County")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lee Coan, deputy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Frank H. Depender, deputy")]), _vm._v(" "), _c('p', {
    staticClass: "subhead3"
  }, [_c('i', [_vm._v("El Dorado County")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Archie Bosquit, sheriff, El Dorado County (father of John Bosquit)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Bosquit, deputy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Louis Phillip (Will) Stringer, civilian/volunteer")]), _vm._v(" "), _c('p', {
    staticClass: "subhead3"
  }, [_c('i', [_vm._v("Sacramento County")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Elijah Carson Hart, judge")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("David Reese, sheriff, Sacramento County")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Edward Reese, deputy, Sacramento County (son of David Reese)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Brown, undersheriff")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Griffin, deputy sheriff")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jack Hunter, deputy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("George Winterbrock, deputy")]), _vm._v(" "), _c('p', {
    staticClass: "subhead3"
  }, [_c('i', [_vm._v("Amador County")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Tomas K. Norman, sheriff, Amador County")]), _vm._v(" "), _c('p', {
    staticClass: "subhead3"
  }, [_c('i', [_vm._v("Reno, Nevada")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Hayes, sheriff, Washoe County")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sharkey, deputy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William Maxwell, deputy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles Leeper, chief of police, Reno, Nevada")]), _vm._v(" "), _c('p', {
    staticClass: "subhead3"
  }, [_c('i', [_vm._v("Company H")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Captain Charles Swisler")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lieutenant Smith")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Festus Rutherford")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Will Rutherford")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("A.J. Bell")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bill Burgess")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Griffith Jones")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Henry Walters")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("A.W. Gill")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William Blake")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISONERS AT")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLSOM")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISON")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Andy Myers")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William A. Leverone")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Joseph Casey, trusty")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("O.C. Clark, trusty")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles Abbott")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Martinez")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALIFORNIA")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Governor George Pardee")]), _vm._v(" "), _c('p', {
    staticClass: "subhead3"
  }, [_c('i', [_vm._v("Citizens")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Elizabeth “Lizzie” Cosens, resident of El Dorado County (wife of George F.)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("George F. Cosens, resident of El Dorado County (husband of Lizzie)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sanford Diehl and family")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Anna Jurgens")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Andrew Kamenzind")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Fred Twitchell")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("W.W. Hoyt, El Dorado County supervisor (Twitchell’s grandfather)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("David Gipe, caretaker of the Grand Victory Mine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Louis Meiss, rancher in El Dorado County")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff515dd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Folsom_Prison.vue
// module id = 81
// module chunks = 0